import React, { useEffect, useState } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { SIZES } from '../../styles/theme'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import startQuiz from '../../images/mobile/mobile-start-quiz.png'
import back from '../../images/booth/back_icon.png'
import next from '../../images/booth/next_arrow.png'
import prev from '../../images/booth/prev_arrow.png'
import complete from '../../images/booth/check.png'

const Wrapper = styled.div`
  padding: 20px 0;
  font-size: 12px;
  /* border-top: solid 3px #c69dff; */
  border-bottom: solid 3px #c69dff;
  /* margin-bottom: 20px; */
  width: 100%;

  .kiosk-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    .back-button {
      cursor: pointer;
      img {
        height: 8px;
      }
      small {
        margin: 0 8px;
        font-weight: 500;
      }
    }
  }
  .booth-kiosk-item-icon {
    height: 40px;
  }

  .booth-kiosk-item-label {
    font-size: 17px;
    width: 100%;
    color: #492379;
    margin: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    p {
      color: #3A2D86;
      margin: 0;
      font-size: 14px;
    }
  }
  
  .kiosk-question {
    padding-top: 20px;
    .navigate {
      text-align: right;
      img {
        width: 10%;
      }
    }
  }
  .status {
    align-self: center;
    small {
      text-align: right;
      color: #305F72;
      font-size: 0.85em;
      letter-spacing: -1px;
    }
  }
  .progress {
    background-color: #B6F7F2;
    border-radius: 10px;
    height: 8px;
  }
  .progress-bar {
    background-color: #26B4A9;
  }
  .stats {
    text-decoration: underline;
    color: #26B4A9;
    font-size: 14px;
    margin-left: 12px;
    cursor: pointer;
    font-weight: 400;
  }
  .message-container {
    text-align: center;
    font-weight: 600;
    color: #3A2D86;
    img {
      width: 25%;
    }
    .screen-title {
      font-size: 16px;
      margin-bottom: 0;
    }
    .result {
      font-size: 18px;
      margin-bottom: 0;
    }
  }
`
const ChoiceItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-bullet {
    margin-right: 8px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid #3A2D86;
    .bullet {
      height: 10px;
      border-radius: 50%;
      padding: 6px;
      background-color: ${(props) => props.selected ? '#26B4A9' :'white'};
    }
    .show-correct {
      background-color: red;
    }
  }
  .choice-text {
    color: #3C3C3C;
    font-size: 14px;
    margin: 4px 0;
  }
  ${SIZES.mobile} {
    align-items: flex-start;
    .check-bullet {
      margin-right: 12px;
      margin-top: 2px;
    }
    .choice-text {
      margin: 0;
      margin-bottom: 8px;
    }
  }
`


export default function MobileKioskSection({ quiz, kioskSection, setKioskSection, isFinishScreen, setIsFinishScreen }) {
  const [currentLesson, setCurrentLesson] = useState(0)
  const [answer, setAnswer] = useState('')
  const lesson = quiz[currentLesson] || {question:"",choices:[{id:"",text:""}]}

  useEffect(() => {
    if (currentLesson === quiz.length) {
      setIsFinishScreen(true)
      setKioskSection(false)
    }
  }, [currentLesson])

  const toggleKioskSection =() => {
    if (isFinishScreen) {
      setIsFinishScreen(!isFinishScreen)
      setCurrentLesson(0)
      setAnswer('')
    } else {
      setKioskSection(!kioskSection)
    }
  }
  const answerQuestion = (id) => {
    setAnswer(id)
  }
  const onClickBtn = (btn) => {
    if (btn === "next"){ 
      if(answer === ''){
        toast("Please select an answer.")
      }else{
        const payload = {
          quizId: quiz.id,
          answer: answer,
          // order: viewQuestion.order,
        }
        // dispatch(submitAnswer(payload))
        setCurrentLesson(currentLesson + 1)
      }
    }
    if (btn === "prev") setCurrentLesson(currentLesson - 1)
    setAnswer('')
  }

  return (
    <Wrapper>
      <div className="booth-kiosk-item-label">
        <div className="w-100">
          <div className="kiosk-header">
            <strong>Quiz</strong> 
            { (kioskSection || isFinishScreen)  && 
              <strong className="back-button" onClick={toggleKioskSection}>
                <img src={back} alt="back"/>
                <small>{kioskSection ? 'Quit' : 'Back'}</small>
              </strong>
            }
          </div>
          { !kioskSection && !isFinishScreen ? 
            <p>Spare 3 mins to answer this questionare</p> 
            :
            kioskSection ?
            <div className="d-flex justify-content-between w-100">
              <div className="status" style={{width: '60%'}}>
                <ProgressBar variant="default" now={(currentLesson+1)/quiz.length * 100} />
              </div>
              <div className="status">
                <small>Question {currentLesson+1} out of {quiz.length}</small>
              </div>
            </div>
            :
            null
          }
        </div>
        { (!kioskSection && !isFinishScreen) && <img src={startQuiz} className="booth-kiosk-item-icon" alt="chat-icon" onClick={toggleKioskSection}/>}
      </div>
      {
        kioskSection &&
        <div className="kiosk-question">
          <p className="question-text">{lesson.question}</p>
          {
            lesson.choices.map((option)=>(
              <ChoiceItem
                key={option.id}
                onClick={()=>answerQuestion(option.id)} 
                selected={true}
                selected={option.id === answer}
                // selected={option.id === (lesson.answer !== null ? lesson.answer : answer)}
              >
                <div className="check-bullet">
                  <div className="bullet"></div>
                  {/* <div className={(lesson.answer !== null && choice.id === lesson.correct_answer && choice.id !== lesson.answer) ? "bullet show-correct" : "bullet"} ></div> */}
                </div>
                <p className="choice-text">{option.text}</p>
                
              </ChoiceItem>
            ))
          }
          <div className="navigate">
            { currentLesson > 0 && <img id="prev-button" src={prev} alt="prev icon" onClick={()=>onClickBtn('prev')} />}
            { currentLesson !== quiz.length && <img id="next-button" src={next} alt="next icon" onClick={()=>onClickBtn('next')} />}
          </div>
        </div>
      }
      {
        isFinishScreen &&
        <div className="message-container">
          <p className="screen-title">Thank You For Completing The Questionnaire!</p>
          <img src={complete} alt="complete tick"/>
          <div>
            <p className="result">You score 9 out of 10!</p>
          </div>
        </div>
      }
    </Wrapper>
  )

}
